import { isServer } from "utils/env";
import fetch from "utils/fetch";
import { Platform, CommonRuntime, getRuntime } from "utils/runtime";

const generateDomain = function generateDomain(isUat: boolean = false, initDomain: string) {
	if (isUat) {
		return `${initDomain}.ezbuy.dev`;
	}
	return `${initDomain}.ador.com`;
};
interface GenerateLitbAPIAddressProps {
	platform: Platform;
	isuat: boolean;
	isPre: boolean;
}
const generateLitbAPIAddress = function generateLitbAPIAddress({
	platform,
	isuat,
	isPre,
}: Partial<GenerateLitbAPIAddressProps>) {
	const apiDomain = generateDomain(
		isuat,
		platform === Platform.WEB ? "litbador-en-web-%SERVICE_TYPE%" : "litbador-en-mweb-%SERVICE_TYPE%",
	);

	let webapiDomain: string;
	if (isuat) {
		webapiDomain = apiDomain.replace("%SERVICE_TYPE%", "api-kdev0-api");
	} else if (isPre) {
		webapiDomain = apiDomain.replace("%SERVICE_TYPE%", "pre").replace("mweb", "web");
	} else {
		webapiDomain = apiDomain.replace("%SERVICE_TYPE%", "api");
	}
	webapiDomain = webapiDomain.replace("..", ".");
	const protocal = "https";
	return `${protocal}://${webapiDomain}/api`;
};
interface Options {
	runtime?: CommonRuntime;
}
export default function webapi<T>(method: string, params: any, options?: Options): Promise<T> {
	const runtime = isServer ? options.runtime : options.runtime || getRuntime();
	const platform = runtime?.platform || Platform.WEB;
	const apiDomain = `${generateLitbAPIAddress({
		isuat: runtime?.isUat,
		platform,
		isPre: (runtime?.hostname || window?.location?.hostname || "")?.includes("pre-"),
	})}`;
	return fetch(method, params, { apiDomain, cookie: isServer ? runtime?.cookie : undefined });
}
